import styles from './style.postcss';

import React from 'react';

import { PageCard, ProgressBar, testClass } from 'omni-common-ui';
import ScoreStar from '../ScoreStar';
import ScoreBand from '../ScoreBand';
import PropTypes from 'prop-types';
import { getHfv4BandForScore } from '../ScoreBand/hfv4ScoreBands';

export const SkillScoreCard =
({ skillName, skillDescription, scorePercentage, studentResultForSkill, isSSCourseTypeGroup }) => {
  const band = getHfv4BandForScore(scorePercentage);
  const bandColorStyle =
    !isSSCourseTypeGroup && band ? { color: band.color } : undefined;
  let suggestionsElem = null;
  if (studentResultForSkill.suggestions && studentResultForSkill.suggestions.size > 0) {
    suggestionsElem = <div className={styles.SkillScoreCard_suggestions}>
      <h4 className={styles.SkillScoreCard_suggestionsHeading}>Suggestions</h4>
      <ul>
        { studentResultForSkill.suggestions.map((suggestion) => (<li>{suggestion}</li>)) }
      </ul>
    </div>;
  }
  return (<PageCard className={styles.SkillScoreCard}>
    <PageCard.Content>
      <h4 className={styles.SkillScoreCard_heading} style={bandColorStyle}>
        <span className={testClass('pt-skill')}>{skillName}</span>&nbsp;
        {! isSSCourseTypeGroup && `${scorePercentage}%`}
      </h4>
      <div className={styles.SkillScoreCard_progressWrapper}
          style={bandColorStyle}>
        {isSSCourseTypeGroup ?
          <ScoreStar currentResult={studentResultForSkill.currentResult}
              fullMark={studentResultForSkill.fullMark} /> :
          <ProgressBar className={styles.SkillScoreCard_progressBar}
              value={studentResultForSkill.currentResult}
              max={studentResultForSkill.fullMark}
              larger
              rounded />}
        {/* <ArrowLink className={styles.SkillScoreCard_mistakesLink} to={'.'}>
              Mistakes
            </ArrowLink> */}
      </div>
      <div>
        <ScoreBand className={styles.SkillScoreCard_scoreBand}
            score={scorePercentage}
            style={bandColorStyle}
            textKey="name" />
        <p className={styles.SkillScoreCard_description}>
          {skillDescription}
        </p>
      </div>
      {suggestionsElem}
    </PageCard.Content>
  </PageCard>);
};

SkillScoreCard.propTypes = {
  skillName: PropTypes.string.isRequired,
  skillDescription: PropTypes.string.isRequired,
  scorePercentage: PropTypes.number.isRequired,
  studentResultForSkill: PropTypes.object.isRequired,
  isSSCourseTypeGroup: PropTypes.bool.isRequired,
};

export default SkillScoreCard;



// WEBPACK FOOTER //
// ./containers/Group/UnitReportHFv4/StudentReportView/SkillScoreCard/index.jsx